<!-- eslint-disable -->
<template lang="pug">
    .game-buttons
        .game__button(v-if="user.type !== 'student' && user.type !== 'olympiad-student'")
            cs-button(
                color="blue",
                pattern="primary-outline",
                @click="$router.push({name: 'homework:create'})"
                :disabled="areSchoolsBlocked",
            )
                | {{ $i18n.t('dashboard.dashboard_education_homework') }}
        .game__button
            cs-button(
                color="blue",
                pattern="primary-outline",
                @click="$router.push({name: 'trainer:games'})"
                :disabled="areSchoolsBlocked || hasUncompletedHomeworks",
            )
                | {{ $i18n.t('dashboard.dashboard_education_freeGame') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import Trainer from '../../../utils/trainer/trainer.js';
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import HomeworkApi from '../../../api/homework/homework.js';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        mixins: [BillingBlockMixin, Trainer],
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
            hasUncompletedHomeworks () {
                return this.homeworks && this.homeworks.some(homework => {
                    return !homework.isBlocked
                            && homework.exercises.length > 0
                            && homework.exercises[0].courseType === _.kebabCase(this.selectedCourse);
                });
            },
        },
        data () {
            return {
                homeworks: null,
                serverDate: null,
                isLoading: false
            }
        },
        mounted () {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                HomeworkApi.uncompletedHomework({course: this.selectedCourse}).then(response => {
                    this.homeworks = _.orderBy(response.homeworks, 'date');
                    this.serverDate = response.serverDate;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            },
            isHomeworkDisabled(homework) {
                return (!homework.isOverdue || homework.isBlocked)
                        || !this.isBeforeCurrentDate(homework)
                        || this.areSchoolsBlocked
                        || homework.isFromBlockedSchool
            },
            isBeforeCurrentDate(homework) {
                return !moment(this.serverDate).isBefore(moment(homework.dateAsIsoString));
            },
            formatDate(date) {
                return moment(date).format('DD MMMM')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .game-buttons {
        display: flex;
        margin: 0 -10px;
        @media screen and (max-width: 400px) {
            flex-direction: column;
        }
    }

    .game__button {
        display: inline-flex;
        padding: 10px;
    }
</style>
